/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanSelectionRequest
 */
export interface PlanSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof PlanSelectionRequest
     */
    planCode: string;
}

/**
 * Check if a given object implements the PlanSelectionRequest interface.
 */
export function instanceOfPlanSelectionRequest(value: object): value is PlanSelectionRequest {
    if (!('planCode' in value) || value['planCode'] === undefined) return false;
    return true;
}

export function PlanSelectionRequestFromJSON(json: any): PlanSelectionRequest {
    return PlanSelectionRequestFromJSONTyped(json, false);
}

export function PlanSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'planCode': json['planCode'],
    };
}

export function PlanSelectionRequestToJSON(json: any): PlanSelectionRequest {
    return PlanSelectionRequestToJSONTyped(json, false);
}

export function PlanSelectionRequestToJSONTyped(value?: PlanSelectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planCode': value['planCode'],
    };
}

